import { ToastContext } from '../components/Toast/ToastContext';
import { useContext } from 'react';

/**
 * Provides access to methods to add and remove toasts
 * @returns object with a toast property that contains the show and remove methods
 */
export const useToast = () => ({
  toast: useContext(ToastContext)
});